import {post} from "../../commons/Commons";
import {CORP_REPORT_ADAPT_URL} from "../../commons/Routing";

export const REPORT_ADAPT_REQUEST = "REPORT_ADAPT_REQUEST";
export const REPORT_ADAPT_SUCCESS = "REPORT_ADAPT_SUCCESS";
export const REPORT_ADAPT_ERROR = "REPORT_ADAPT_ERROR";

export const REPORT_ADAPT_IS_BUILT = "REPORT_ADAPT_IS_BUILT";

export const REPORT_ADAPT_TOGGLE_PERSON = "REPORT_ADAPT_TOGGLE_PERSON";


export function togglePerson(person_id) {
  return {
    type: REPORT_ADAPT_TOGGLE_PERSON,
    payload: person_id
  }
}

export function reportIsBuilt() {
  return {
    type: REPORT_ADAPT_IS_BUILT,
    payload: true,
  }
}

export function reportIsBuiltClear() {
  return {
    type: REPORT_ADAPT_IS_BUILT,
    payload: false,
  }
}


export function getReport(person) {

  return (dispatch, getStore) => {
    dispatch({
      type: REPORT_ADAPT_REQUEST,
      payload: null,
    });

    let persons = getStore().report_adaptation.selected || [];
    person = persons.length ? persons[0] : person;

    post(CORP_REPORT_ADAPT_URL, {person_id: person})
      .done((d) => {

        if (d.status === 'ok') {
          dispatch({
            type: REPORT_ADAPT_SUCCESS,
            payload: d.data,
          });
        } else {
          dispatch({
            type: REPORT_ADAPT_ERROR,
            payload: null,
          });
        }
      })
      .fail((jqXHR) => {
        let error = jqXHR.responseText;
        if (jqXHR.responseJSON && jqXHR.responseJSON.detail) {
          error = jqXHR.responseJSON.detail;
        }

        dispatch({
          type: REPORT_ADAPT_ERROR,
          payload: error,
        });
      })
  }

}